import {Link} from "react-router-dom";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faChevronRight, faEnvelope} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import AuthAPI  from '~/api/authApi';

function ForgotPassword() {
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm();

    const onSubmit = (data) => {
        AuthAPI.forgotPassword(data.Email)
        .then((res) => {
            if (res.data?.Succeeded) {
                navigate(`/auth/reset-password/confirmation?${data.Email}`, { replace: true });
            }
            else{
                if(res.data?.IsLock){
                    navigate('/auth/lock-account', { replace: true });
                }
                else{
                    navigate('/auth/failed', { replace: true });
                }
            }
        })
        .catch((err) => {
            ;
        })
    }
    return (
        <div className="px-xxl-5">
            <div className="text-center mb-6">
                <h4 className="text-body-highlight">Forgot your password?</h4>
                <p className="text-body-tertiary mb-3 fs-8-1">Enter your email below and we will send <br
                    className="d-sm-none"/>you a reset link.</p>
                <form className="mb-3" onSubmit={handleSubmit(onSubmit)}>
                    <div className="text-start">
                        <label className="form-label" htmlFor="email">Email address</label>
                        <div className="form-icon-container">
                            <input className="form-control form-icon-input" id="Email" type="text" placeholder="name@example.com"
                                   {...register("Email", {
                                       required: "Email is required.",
                                       pattern: {
                                           value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                           message: "Invalid email address"
                                       }
                                   })}
                            />
                            <FontAwesomeIcon icon={faEnvelope} className="form-icon fs-9 text-body"/>
                        </div>
                        {errors.Email && (
                            <p className="fs-9 fw-bold text-danger mt-1">{errors.Email.message}</p>
                        )}
                    </div>
                    <button type="submit" className="btn btn-primary mt-4 w-100">Send
                        <FontAwesomeIcon icon={faChevronRight} className="ms-2"/>
                    </button>
                </form>
                <Link className="fs-9 fw-bold" to='/home'>Still having problems?</Link>
            </div>
        </div>
    )
}

export default ForgotPassword